interface ApiEnvelope<T> {
  ok: boolean;
  data: T;
  error?: { code: string; message: string; details?: unknown };
  requestId?: string;
}

export class ApiError extends Error {
  code: string;
  status: number;
  details?: unknown;
  constructor(message: string, code = 'API_ERROR', status = 500, details?: unknown) {
    super(message);
    this.name = 'ApiError';
    this.code = code;
    this.status = status;
    this.details = details;
  }
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    credentials: 'include',
    ...init,
    headers: {
      ...(init?.body instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
      ...init?.headers,
    },
  });
  let payload: ApiEnvelope<T> | null = null;
  try { payload = await response.json() as ApiEnvelope<T>; } catch { /* non-JSON response */ }
  if (!response.ok || payload?.ok === false) {
    throw new ApiError(payload?.error?.message || `Request failed with status ${response.status}`, payload?.error?.code, response.status, payload?.error?.details);
  }
  return payload?.data as T;
}

export const api = {
  get<T>(path: string) { return request<T>(path); },
  post<T>(path: string, body?: unknown) { return request<T>(path, { method: 'POST', body: body === undefined ? undefined : JSON.stringify(body) }); },
  patch<T>(path: string, body?: unknown) { return request<T>(path, { method: 'PATCH', body: body === undefined ? undefined : JSON.stringify(body) }); },
  delete<T>(path: string) { return request<T>(path, { method: 'DELETE' }); },
  async upload(file: File, kind: 'hostel_media' | 'ad_creative' | 'agency_logo' | 'agency_cover' | 'agency_document' | 'hostel_document' | 'receipt' | 'chat_attachment') {
    const form = new FormData();
    form.set('file', file);
    form.set('kind', kind);
    return request<{ objectKey: string; url: string; contentType: string; size: number; contentHash: string }>('/api/uploads', { method: 'POST', body: form });
  },
};

export function formatMoney(amount: number | null | undefined, currency = 'GHS') {
  if (amount === null || amount === undefined) return 'Price unavailable';
  return `${currency} ${(amount / 100).toLocaleString(undefined, { maximumFractionDigits: 2 })}`;
}

export function formatDistance(metres: number | null | undefined) {
  if (metres === null || metres === undefined) return 'Distance unavailable';
  return metres < 1000 ? `${metres} m` : `${(metres / 1000).toFixed(1)} km`;
}

export function toDateInput(date: Date) {
  return date.toISOString().slice(0, 10);
}
